import { Menu } from "@headlessui/react";
import { SocialMediaShareMenuItems } from "~/components/SocialMediaShareMenu/SocialMediaShareMenuItems";

export type SocialMediaShareMenuProps = {
  menuButton: React.ReactNode;
  shareTitle: string;
  shareUrl: string;
};

export const SocialMediaShareMenu: React.FC<SocialMediaShareMenuProps> = ({
  menuButton,
  shareTitle,
  shareUrl,
}) => (
  <Menu>
    {({ open }) => (
      <div className="relative">
        {menuButton}
        <SocialMediaShareMenuItems
          isOpen={open}
          shareTitle={shareTitle}
          shareUrl={shareUrl}
        />
      </div>
    )}
  </Menu>
);
